import { PaymentStatus } from '~entities/payment/constants';

import { cn } from '~shared/shadcn/lib/utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~shared/shadcn/ui/select';

export interface PaymentStatusSelectorProps {
  value?: PaymentStatus | undefined;
  skip?: Array<PaymentStatus>;
  onChange: (value: PaymentStatus | undefined) => void;
  placeholder?: string;
  className?: string;
}

export const PaymentStatusSelector = ({
  value,
  skip = [],
  onChange,
  className,
  placeholder = 'Select Status',
}: PaymentStatusSelectorProps) => {
  const handleValueChange = (selectedValue: string) => {
    const status = selectedValue as PaymentStatus;
    onChange(status);
  };

  const filteredStatuses = Object.entries(PaymentStatus).filter(
    ([, statusValue]) => !skip.includes(statusValue as PaymentStatus),
  );

  return (
    <Select value={value} onValueChange={handleValueChange}>
      <SelectTrigger
        className={cn(className, !value && 'text-muted-foreground')}
      >
        <SelectValue className='' placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {filteredStatuses.map(([key, statusValue]) => (
          <SelectItem key={key} value={statusValue}>
            {statusValue
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
